<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <form (ngSubmit)="Validate(FilterForm)" #FilterForm="ngForm" name="FilterForm" novalidate>
        <div class="card-body p-0">
            <div class="card mb-1">
                <div class="card-header">
                    Questionnaire
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4 px-1">
                            <label>Template Name</label>
                            <input name="TemplateName" maxlength="300" class="form-control" placeholder="Ex."
                                [(ngModel)]="Filter.TemplateName" #TemplateName="ngModel" required>
                            <div class="invalid-feedback">
                                Please enter Template name.
                            </div>
                        </div>
                        <div class="col-md-4 px-1">
                            <label for="WebESSModuleMasterId" class="form-font-label">Module<span
                                    class="text-danger">*</span></label>
                            <ng-select name="WebESSModuleMasterId" [(ngModel)]="Filter.WEBESSModuleMasterId"
                                #WebESSModuleMasterId="ngModel" placeholder="--Select Module--" required
                                [disabled]="Filter.ESS_QuestionnareTemplateMainId > 0">
                                <ng-option *ngFor="let Module of Modules"
                                    [value]="Module.WebESSModuleMasterID">{{Module.ModuleName}}</ng-option>
                            </ng-select>

                            <div class="invalid-feedback">
                                Please select module!
                            </div>
                        </div>
                        <div class="col-md-1 px-1"><br>
                            &nbsp;&nbsp; &nbsp; <label class="Label">
                                Active
                                <input type="checkbox" name="Active" [(ngModel)]="Filter.IsActive" #Active="ngModel"
                                    ngbCheckbox />
                            </label>
                        </div>
                        <div class="col-md-2 px-1"><br>
                            &nbsp;&nbsp; &nbsp; <label class="Label">
                                Default Template
                                <input type="checkbox" name="deftemplate" [(ngModel)]="Filter.DefaultTemplate" #deftemplate="ngModel"
                                    ngbCheckbox />
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mb-1">
                <div class="card-header">
                    <div class="row">
                        <div class="col">Question</div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled"
                                (click)="AddQuestion()">
                                <i class="bi bi-plus" *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled ? 'Add Question' : 'Loading...'}}
                            </button>
                        </div>
                    </div>
                </div>

                <div *ngFor="let question of Filter.ESS_QuestionnareTemplateDetails; let i = index">
                    <div class="card">
                        <div class="card-body">
                            <h6 class="card-subtitle mb-2 text-muted">
                                <div class="row">
                                    <div class="col-md-2">Question - {{i + 1}}</div>
                                    <div class="col">
                                        <label for="DefaultShift" class="form-font-label">Type : </label>
                                        <div class="btn-group btn-group-toggle">
                                            <label class="form-check-label link-dark px-1 form-font-label"
                                                ngbButtonLabel>
                                                <input class="form-check-input" type="radio" value="S"
                                                    name='DefaultShift{{i}}' [(ngModel)]="question.AnswerIsText"
                                                    [ngModelOptions]="{standalone: true}">
                                                IsScore
                                            </label>
                                            <label class="form-check-label link-dark px-1 form-font-label"
                                                ngbButtonLabel>
                                                <input class="form-check-input" type="radio" value="T"
                                                    name='DefaultShift{{i}}' [(ngModel)]="question.AnswerIsText"
                                                    [ngModelOptions]="{standalone: true}">
                                                IsTextbox
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-auto">
                                        <i class="bi bi-x-circle text-danger" (click)="DeleteQuestion(i)"
                                            *ngIf="!isDisabled"></i>
                                    </div>
                                </div>
                            </h6>
                            <div class="row pb-2">
                                <div class="row">
                                    <div class="col-md-7 px-1">
                                        <textarea type="text" class="form-control" name="Question{{i}}"
                                            placeholder="Ex. " [(ngModel)]="question.Questions" #Question="ngModel"
                                            rows="2" required></textarea>
                                        <div class="invalid-feedback">
                                            Please enter Question!
                                        </div>
                                    </div>
                                    <div class="col-md-3 px-1">
                                        <label>Group Name</label>
                                        <input name="GroupName{{i}}" maxlength="200" class="form-control"
                                            placeholder="Group Name" [(ngModel)]="question.QuestionGroupName"
                                            #GroupName="ngModel" required>
                                        <div class="invalid-feedback">
                                            Please enter Group Name.
                                        </div>
                                    </div>
                                    <div class="col-md-1 px-1">
                                        <label>Sort by</label>
                                        <input name="sortby{{i}}" class="form-control" type="text" maxlength="2"
                                            [(ngModel)]="question.QuestionSequence" #sortby="ngModel"
                                            (keypress)="common.NumberOnly($event,common.allowDot(question.QuestionSequence))"
                                            (keyup)="common.NumberOnly($event,common.allowDot(question.QuestionSequence))"
                                            style="text-align: right;" (input)="validateInput($event,i)" required>
                                        <div class="invalid-feedback">
                                            Please enter Sort by.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                    (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>
                <button type="submit" *ngIf="this.common.PageRight.IsAdd || this.common.PageRight.IsEdit"
                    class="btn btn-sm btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}</button>
            </div>
        </div>
    </form>
</div>